import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Datenschutz.css';

function Datenschutz() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="datenschutz-container">
      <div className="datenschutz-content">
        <h1>Datenschutzerklärung</h1>

        <section>
          <h2>Verantwortliche Stelle</h2>
          <p>
            Linda Geske<br />
            Hauptstr. 37B<br />
            61209 Echzell<br />
            <a href="mailto:kleinkram@tierarztpraxis-geske.de">kleinkram@tierarztpraxis-geske.de</a><br />
            06008-251
          </p>
        </section>

        <section>
          <h2>1. Art der verarbeiteten Daten</h2>
          <p>Über das Bestellformular werden ausschließlich folgende personenbezogene Daten erhoben:</p>
          <ul>
            <li>Name</li>
            <li>E-Mail-Adresse</li>
            <li>Telefonnummer</li>
            <li>Rechnungsadresse</li>
            <li>Gewählte Produkte/Gravurdetails</li>
          </ul>
          <p>Das Programm selbst speichert keine personenbezogenen Daten dauerhaft.</p>
        </section>

        <section>
          <h2>2. Zweck der Verarbeitung</h2>
          <p>Die Daten werden ausschließlich verwendet für:</p>
          <ul>
            <li>Kontaktaufnahme zur Abstimmung der Bestellung</li>
            <li>Erstellung und Versand einer Rechnung</li>
            <li>Durchführung der vereinbarten Lasergravur</li>
            <li>Rückfragen zur Bestellung</li>
          </ul>
          <p>Es erfolgt keine weitere Nutzung, kein Profiling, keine Weitergabe an Dritte.</p>
        </section>

        <section>
          <h2>3. Übermittlungsweg</h2>
          <p>
            Die im Formular eingegebenen Daten werden ausschließlich per E-Mail an die oben genannte
            verantwortliche Stelle übermittelt.
          </p>
          <p>Eine Speicherung innerhalb der App, auf dem Server oder in Cookies findet nicht statt.</p>
        </section>

        <section>
          <h2>4. Löschung der Daten</h2>
          <p>Alle übermittelten personenbezogenen Daten werden gelöscht, sobald:</p>
          <ul>
            <li>die Bestellung abgeschlossen ist</li>
          </ul>
          <p>und</p>
          <ul>
            <li>die gesetzlich erforderlichen Aufbewahrungsfristen (z. B. steuerrechtlich) erfüllt sind.</li>
          </ul>
          <p>
            Daten, die nicht für die Rechnungserstellung erforderlich sind, werden unmittelbar nach
            Abschluss der Kommunikation gelöscht.
          </p>
        </section>

        <section>
          <h2>5. Rechtsgrundlage der Verarbeitung</h2>
          <p>
            Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. b DSGVO
            (Vertragserfüllung bzw. Durchführung vorvertraglicher Maßnahmen).
          </p>
        </section>

        <section>
          <h2>6. Ihre Rechte als betroffene Person</h2>
          <p>Sie haben gemäß DSGVO folgende Rechte:</p>
          <ul>
            <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
            <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
            <li>Recht auf Löschung (Art. 17 DSGVO)</li>
            <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Recht auf Widerspruch (Art. 21 DSGVO)</li>
          </ul>
          <p>Anfragen oder Löschwünsche können jederzeit über die oben genannten Kontaktwege gestellt werden.</p>
        </section>

        <section>
          <h2>7. Sicherheit der Verarbeitung</h2>
          <p>Die Übermittlung erfolgt per E-Mail.</p>
          <p>Es werden keine zusätzlichen Systeme, Trackingdienste oder Analysedienste verwendet.</p>
        </section>

        <section>
          <h2>8. Keine Weitergabe an Dritte</h2>
          <p>
            Es erfolgt keine Weitergabe personenbezogener Daten an externe Stellen, außer wenn gesetzlich
            vorgeschrieben (z. B. steuerliche Aufbewahrungspflichten).
          </p>
        </section>

        <div className="datenschutz-actions">
          <button className="btn btn-primary" onClick={handleBack}>
            Zurück
          </button>
        </div>
      </div>
    </div>
  );
}

export default Datenschutz;
